export default __webpack_public_path__ + "static/media/cancelIco.fd154e67.svg";